import { useCurrentUser } from 'api';
import { logger } from 'monitor';
import { useEffect, useRef } from 'react';
import { isReactNativeWebView, postToNativeWebView } from '../nativeBridge';

/**
 * When running inside the React Native shell, post the authenticated user to
 * native as soon as it loads so the shell can identify the user in PostHog and
 * Datadog before any meaningful events fire. Without this, identification only
 * happens when the camera is opened (the only other path that posts auth).
 */
export const useIdentifyNativeShell = () => {
  const { data: user } = useCurrentUser();
  const lastPostedUserSignature = useRef<string | null>(null);

  useEffect(() => {
    if (!isReactNativeWebView()) {
      logger.debug('Not in React Native WebView, skipping native identification');
      return;
    }
    if (!user) {
      logger.debug('No user, not posting to native');
      return;
    }
    const userSignature = `${user.id}:${user.language ?? ''}`;
    if (lastPostedUserSignature.current === userSignature) {
      logger.debug('User signature unchanged, not posting to native again');
      return;
    }

    logger.debug('Posting user to native WebView', { language: user.language, userId: user.id });
    postToNativeWebView('userChange', {}, { user });
    lastPostedUserSignature.current = userSignature;
  }, [user]);
};
